import { IAddress } from '@commenda/types';
import {
  CorporationHasDirectorAdditionalInformation,
  DirectorPersonalDetails,
} from '@commenda/types/src/random';
import { fetcher } from '@commenda/utils';
import { LegacyDocumentType } from '@prisma/client';

type DirectorFileToAdd = {
  fileName: string;
  fileUrl: string;
  documentType: LegacyDocumentType;
};

export type CreateCorporationHasDirector = {
  corporationId: number;
  additionalDirectorInformation?: CorporationHasDirectorAdditionalInformation;
  filesToAdd?: DirectorFileToAdd[];
};

// TODO: This is not a full SDK, there are many properties on the API that aren't included here yet.
export type CreateDirectorRequest = {
  corporationHasDirector?: CreateCorporationHasDirector[];
  directorFirstName?: string;
  directorLastName?: string;
  operatingAddress?: IAddress;
  personalDetails?: DirectorPersonalDetails;
  companyId: number;
  corporationIds?: number[];
  dateOfBirth?: string;
  number?: string;
  email?: string;
  ssn?: string;
};

export async function createDirector(
  director: CreateDirectorRequest,
  token: string | undefined
): Promise<Response> {
  const res = await fetcher(
    'director',
    {
      method: 'POST',
      body: director,
    },
    token
  );

  return res;
}
